// extracted by mini-css-extract-plugin
export var currentStep = "_gi-2";
export var nodeCard = "_gi-0";
export var pathHighlighted = "_gi-1";